import React from "react"
export default function LandingPartnerSection() {
  return (
    <div className="bg-white pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8 divide-y-2 divide-gray-200 ">
      <div className="  relative max-w-lg mx-auto lg:max-w-7xl pb-10">
        <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
          Strategic partners
        </h2>
      </div>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-6">
          <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
            <img
              className="h-12"
              src="https://cr14.ee/content/partners.CCDCOE.png"
              alt="Tuple"
            />
          </div>
          <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
            <img
              className="h-12"
              src="https://cr14.ee/content/partners.KAITSEMIN.png"
              alt="Mirage"
            />
          </div>
          <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
            <img
              className="h-12"
              src="https://cr14.ee/content/partners.mil.png"
              alt="StaticKit"
            />
          </div>
          <div className="col-span-1 flex justify-center md:col-span-3 lg:col-span-1">
            <img
              className="h-12"
              src="https://cr14.ee/content/partners.eucybernet.png"
              alt="Transistor"
            />
          </div>
          <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
            <img
              className="h-12"
              src="https://cr14.ee/content/partners.itl.svg"
              alt="Workcation"
            />
          </div>
          <div className="col-span-2 flex justify-center md:col-span-3 lg:col-span-1">
            <img
              className=" h-8"
              src="https://cr14.ee/content/partners.thinnect.png"
              alt="Workcation"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
